import { type Product, PRODUCTS } from "@/constants/products";

/**
 * Products the user can switch to, based on the subscription's client ids.
 * @param clientIds `plan_package_client_ids` from the active subscription
 * @returns the configured products whose client id is in the list
 */
export const getAvailableProducts = (clientIds: string[]): Product[] =>
  PRODUCTS.filter((product) => clientIds.includes(product.clientId));
